/// <amd-module name="SuiteCommerce.StockNotifications.Component"/>
define("SuiteCommerce.StockNotifications.Component", ["require", "exports", "SuiteCommerce.StockNotifications.Subscription.Create.View", "SuiteCommerce.StockNotifications.Instrumentation"], function (require, exports, Subscription_Create_View_1, Instrumentation_1) {
    "use strict";
    return {
        register: function (container) {
            var BaseComponent = container.getComponent('SC.BaseComponent');
            if (BaseComponent) {
                var Component = this.getComponent(container, BaseComponent);
                container.registerComponent(Component);
            }
        },
        getComponent: function (container, BaseComponent) {
            var _this = this;
            return BaseComponent.extend({
                componentName: 'StockNotifications',
                application: container,
                showSubscriptionModal: function (options) {
                    var layout = container.getComponent('Layout');
                    var createView = new Subscription_Create_View_1.SubscriptionCreateView({
                        application: container,
                        title: options.modalTitle,
                        selectedProduct: options.selectedProductId
                    });
                    if (layout) {
                        _this.logComponentUsage();
                        layout.showContent(createView, {
                            showInModal: true
                        });
                        return true;
                    }
                    return false;
                }
            });
        },
        logComponentUsage: function () {
            var log = Instrumentation_1.default.getLog('usage');
            log.setParameters({
                componentArea: 'SC Stock Notifications',
                activity: 'Call modal from component'
            });
            log.submit();
        }
    };
});
